/** InsCoder WANG.J 2026-08-04 B + Homepage journal carousel interactions **/
(function () {
  'use strict';

  var STORAGE_KEY = 'kavalriRecentlyReadArticlesV1';

  function recordArticle(card) {
    var url = card.dataset.articleUrl;
    if (!url) return;

    var parsedUrl;
    try {
      parsedUrl = new URL(url, window.location.origin);
      if (parsedUrl.origin !== window.location.origin || parsedUrl.pathname.indexOf('/blogs/') !== 0) return;
    } catch (error) {
      return;
    }

    var entry = {
      url: parsedUrl.pathname,
      title: card.dataset.articleTitle || '',
      date: card.dataset.articleDate || '',
      blogHandle: card.dataset.blogHandle || ''
    };
    if (!entry.title) return;

    try {
      var history = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(history)) history = [];
      history = history.filter(function (item) { return item && item.url !== entry.url; });
      history.unshift(entry);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, 24)));
    } catch (error) {
      return;
    }
  }

  function init(root) {
    if (!root || root.dataset.journalPreviewBound === 'true') return;
    root.dataset.journalPreviewBound = 'true';

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-journal-article-link]');
      if (!link) return;
      var card = link.closest('[data-journal-article]');
      if (card) recordArticle(card);
    });

    if (typeof window.Swiper === 'undefined') return;

    var slider = root.querySelector('[data-journal-preview-slider]');
    if (!slider) return;

    root.custJournalSwiper = new window.Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 15,
      watchOverflow: true,
      scrollbar: {
        el: root.querySelector('[data-journal-preview-scrollbar]'),
        draggable: true
      },
      pagination: {
        el: root.querySelector('[data-journal-preview-pagination]'),
        clickable: true
      },
      navigation: {
        prevEl: root.querySelector('[data-journal-preview-prev]'),
        nextEl: root.querySelector('[data-journal-preview-next]')
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30
        }
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cust-journal-articles]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-cust-journal-articles]');
    if (root && root.custJournalSwiper) root.custJournalSwiper.destroy(true, true);
  });
})();
/** InsCoder WANG.J 2026-08-04 E + Homepage journal carousel interactions **/
